module.exports = __webpack_public_path__ + "static/online-79d70b477604577b0abe08fef39ba645.mp4";